<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Merge Products</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <!-- <v-row>
              <v-col cols="9">
                <v-autocomplete
                  autocomplete="off"
                  outlined
                  dense
                  v-model="record.productToRemain"
                  :items="products"
                  item-text="Name"
                  item-value="id"
                  label="Product To Maintain"
                ></v-autocomplete>
              </v-col>

              <v-col cols="9">
                <v-autocomplete
                  autocomplete="off"
                  outlined
                  dense
                  v-model="record.productToDiscard"
                  :items="products"
                  item-text="Name"
                  item-value="id"
                  label="Product To Delete"
                ></v-autocomplete>
              </v-col>

              <v-col cols="9">
                <v-btn color="accent" :loading="loader" @click="mergeProducts"
                  >Merge Products</v-btn
                >
              </v-col>
            </v-row> -->
          </v-col>
        </v-row>
      </v-card-text>
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data() {
    return {
      search: null,
      pageItems: 500,
      loader: false,
      record: {},
      editItem: {},
      damagedItem: {},
      transferItem: {},
      store: null,
      stores: [],
      users: [],
      date: null,
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      headers: [
        { text: "Product Name", value: "product.Name" },
        { text: "Available Qty", value: "AvailableQty" },
        // { text: "Action", value: "action" },
      ],
      products: [],
    };
  },
  methods: {
    mergeProducts() {
      if (
        this.record.productToDiscard == undefined ||
        this.record.productToRemain == undefined
      ) {
        this.$refs.snackbar.show("Please select both products!", "red");
      } else {
        let data = this.record;
        const url = "/merge-products";
        const self = this;
        self.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              this.$refs.snackbar.show("Merge Successful", "green");
              this.record = {};
              self.loader = false;
            } else {
              self.loader = false;
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(err, "red");
            self.loader = false;
          });
      }
    },
    getProducts() {
      const self = this;
      //  get store id first
      this.$store
        .dispatch("get", `/products`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // end
    },
  },
  created() {
    Promise.all([this.getProducts()]);
  },
};
</script>

<style lang="scss" scoped>
</style>